import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import countryData from "../data/country.json";

const GlobalExchangeTableEdit = ({ exchange, setExchange, fetchExchanges }) => {
    const [formData, setFormData] = useState({
        receiverCountry: "",
        amount: "",
        fxAmount: "",
        status: "Active",
    });

    useEffect(() => {
        if (exchange) {
            setFormData({
                receiverCountry: exchange.receiverCountry || "",
                amount: exchange.amount || "",
                fxAmount: exchange.fxAmount || "",
                status: exchange.status?.charAt(0).toUpperCase() + exchange.status?.slice(1) || "Inactive",
            });
        }
    }, [exchange]);

    const handleClose = () => setExchange(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

      
       
    };

    const handleSave = async () => {
        if (!exchange?.docId) return;

        try {
            const selectedCountry = countryData.find((c) => c.name === formData.receiverCountry);
            
            await updateDoc(doc(db, "globalExchange", exchange.docId), {
                receiverCountry: formData.receiverCountry,
                amount: parseFloat(formData.amount),
                fxAmount: parseFloat(formData.fxAmount),
                isoCode: selectedCountry?.isoCode || exchange.isoCode,
                receiverCurrency: selectedCountry?.currency || exchange.receiverCurrency,
                currencyCode: "USD",
                status: formData.status.toLowerCase(),
            });

            fetchExchanges();
            handleClose();
        } catch (error) {
            console.error("Error updating global exchange:", error);
            alert("Failed to update exchange rate.");
        }
    };

    return (
        <Modal show={!!exchange} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Global Exchange Rate</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-2">
                        <Form.Label>Receiver Country</Form.Label>
                        <Form.Select
                            name="receiverCountry"
                            value={formData.receiverCountry}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Country</option>
                            {countryData.map((country, idx) => (
                                <option key={idx} value={country.name}>
                                    {country.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>USD Amount</Form.Label>
                        <Form.Control
                            type="number"
                            name="amount"
                            value={1}
                            onChange={handleChange}
                            placeholder="Enter USD amount"
                            min="0"
                            max="10000"
                            step="0.01"
                            readOnly
                        />
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>
                            Exchange Amount {formData.receiverCountry && `(${countryData.find(c => c.name === formData.receiverCountry)?.currency || 'Local Currency'})`}
                        </Form.Label>
                        <Form.Control
                            type="number"
                            name="fxAmount"
                            value={formData.fxAmount}
                            onChange={handleChange}
                           
                        />
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>Status</Form.Label>
                        <div className="d-flex gap-3">
                            {["Active", "Inactive"].map((status) => (
                                <div className="form-check" key={status}>
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="status"
                                        value={status}
                                        id={`edit-status-${status}`}
                                        checked={formData.status === status}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor={`edit-status-${status}`}>
                                        {status}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GlobalExchangeTableEdit;